module.exports = __webpack_public_path__ + "img/Action.27d9ef28.svg";